import { atom } from 'infrastructure/state/jotai.wrapper'

export const mathjaxLoadedAtom = atom(false)
